module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-sunglasses-d708d580.svg";